module.exports = __webpack_public_path__ + "media/images/flags/mg-929451edd4044dba4098efc145f385fe.svg";